export const baseInputVariantsSize40dpBaseHeight = "2.5rem";
export const baseInputVariantsSize56dpBaseHeight = "3.5rem";
export const baseInputVariantsSize56dpBasePx = "1.25rem";
export const baseInputVariantsSize56dpBaseItemSpacing = "0.75rem";
export const baseInputVariantsSize56dpLabelTypography = "400 1rem/1.5rem Inter";
export const baseInputVariantsSize56dpLabelFontWeight = "500";
export const baseInputVariantsSize56dpInputValueTypography = "400 1rem/1.5rem Inter";
export const baseInputVariantsSize56dpInputValueFontWeight = "500";
export const baseInputVariantsSize56dpPlaceholderTypography = "400 1rem/1.5rem Inter";
export const baseInputVariantsSize56dpPlaceholderFontWeight = "500";
export const baseInputVariantsFloatingLabelTrueLabelWrapperPx = "0.25rem";
export const baseInputVariantsFloatingLabelTrueLabelWrapperBgColor = "#fff";
export const baseInputVariantsFloatingLabelTrueLabelWrapperPositionX = "0.75rem";
export const baseInputVariantsFloatingLabelTrueLabelWrapperPositionY = "-8px";
export const baseInputVariantsFloatingLabelTrueLabelWrapperResizingW = "resizing-w-hug";
export const baseInputVariantsFloatingLabelTrueLabelTypography = "400 0.75rem/1rem Inter";
export const baseInputVariantsStateHoverBaseBgColor = "#f3faf9";
export const baseInputVariantsStateActiveBaseBgColor = "#e2f4f1";
export const baseInputVariantsStateFocusBaseOutlineColor = "#70c8be";
export const baseInputVariantsStateFocusBaseOutlineWidth = "0.125rem";
export const baseInputVariantsStateFocusBaseOutlineOffset = "-2px";
export const baseInputVariantsStateFocusLabelColor = "#29a197";
export const baseInputVariantsStateInvalidBaseOutlineColor = "#cf484c";
export const baseInputVariantsStateInvalidLabelColor = "#cf484c";
export const baseInputVariantsStateInvalidInputValueColor = "#cf484c";
export const baseInputVariantsStateInvalidPlaceholderColor = "#fa8b88";
export const baseInputVariantsStateInvalidHoverBaseBgColor = "#fff5f5";
export const baseInputVariantsStateInvalidActiveBaseBgColor = "#ffecea";
export const baseInputVariantsDisabledTrueBaseBgColor = "#eef0f3";
export const baseInputVariantsDisabledTrueBaseOutlineColor = "#dde1e8";
export const baseInputVariantsDisabledTrueLabelColor = "#a0acbe";
export const baseInputVariantsDisabledTrueInputValueColor = "#677893";
export const baseInputVariantsDisabledTruePlaceholderColor = "#a0acbe";
export const baseInputVariantsStyleFilledBaseOutlineWidth = "0px";
export const baseInputVariantsStyleFilledBaseBgColor = "#f6f7f9";
export const baseInputVariantsStyleFilledBaseOutlineOffset = "0px";
export const baseInputVariantsStyleFilledBaseOutlineColor = "transparent";
export const baseInputVariantsStyleFilledLabelColor = "#4c5f7c";
export const baseInputVariantsStyleFilledInputValueColor = "#354764";
export const baseInputVariantsStyleFilledPlaceholderColor = "#8392a9";
export const baseInputVariantsButtonTrueBasePr = "0.25rem";
export const baseInputCompoundVariantsStyleFilledAndStateHoverBaseBgColor = "#e2f4f1";
export const baseInputCompoundVariantsStyleFilledAndStateActiveBaseBgColor = "#d5efec";
export const baseInputCompoundVariantsStyleFilledAndStateInvalidBaseBgColor = "#fff5f5";
export const baseInputCompoundVariantsStyleFilledAndStateInvalidBaseOutlineColor = "transparent";
export const baseInputCompoundVariantsStyleFilledAndStateInvalidLabelColor = "#ac3036";
export const baseInputCompoundVariantsStyleFilledAndStateInvalidInputValueColor = "#ac3036";
export const baseInputCompoundVariantsStyleFilledAndStateInvalidPlaceholderColor = "#e96867";
export const baseInputCompoundVariantsStyleFilledAndStateInvalidHoverBaseBgColor = "#ffecea";
export const baseInputCompoundVariantsStyleFilledAndStateInvalidActiveBaseBgColor = "#ffe3e0";
export const baseInputCompoundVariantsStyleFilledAndDisabledTrueBaseBgColor = "#e7eaef";
export const baseInputCompoundVariantsStyleFilledAndDisabledTrueBaseOutlineColor = "transparent";
export const baseInputCompoundVariantsStyleFilledAndDisabledTrueLabelColor = "#a0acbe";
export const baseInputCompoundVariantsStyleFilledAndDisabledTrueInputValueColor = "#677893";
export const baseInputCompoundVariantsStyleFilledAndDisabledTruePlaceholderColor = "#a0acbe";
export const baseInputCompoundVariantsStyleFilledAndFloatingLabelTrueLabelWrapperPx = "0px";
export const baseInputCompoundVariantsStyleFilledAndFloatingLabelTrueLabelWrapperBgColor = "transparent";
export const baseInputCompoundVariantsStyleFilledAndFloatingLabelTrueLabelWrapperPositionX = "0px";
export const baseInputCompoundVariantsSize56dpAndFloatingLabelTrueLabelWrapperPositionY = "-10px";
export const baseInputCompoundVariantsSize56dpAndFloatingLabelTrueLabelTypography = "400 0.875rem/1.25rem Inter";
export const baseInputCompoundVariantsStyleFilledAndSize40dpAndFloatingLabelTrueLabelWrapperPositionY = "-20px";
export const baseInputCompoundVariantsStyleFilledAndSize56dpAndFloatingLabelTrueLabelWrapperPositionY = "-24px";
export const baseInputCompoundVariantsSize40dpAndButtonTrueButtonSize = "32dp";
export const baseInputCompoundVariantsSize56dpAndButtonTrueButtonSize = "48dp";
export const baseInputSlotsBasePx = "1rem";
export const baseInputSlotsBaseItemSpacing = "0.5rem";
export const baseInputSlotsBaseBgColor = "#fff";
export const baseInputSlotsBaseOutlineColor = "#bec6d3";
export const baseInputSlotsBaseBorderRadius = "0.5rem";
export const baseInputSlotsBaseOutlineWidth = "1px";
export const baseInputSlotsBaseOutlineOffset = "-1px";
export const baseInputSlotsBaseLayout = "layout-row";
export const baseInputSlotsBaseResizingW = "resizing-w-fill";
export const baseInputSlotsBaseResizingH = "resizing-h-fixed";
export const baseInputSlotsLabelColor = "#4c5f7c";
export const baseInputSlotsLabelTypography = "400 0.875rem/1.25rem Inter";
export const baseInputSlotsLabelFontWeight = "400";
export const baseInputSlotsInputValueColor = "#4c5f7c";
export const baseInputSlotsInputValueTypography = "400 0.875rem/1.25rem Inter";
export const baseInputSlotsInputValueFontWeight = "400";
export const baseInputSlotsPlaceholderColor = "#a0acbe";
export const baseInputSlotsPlaceholderTypography = "400 0.875rem/1.25rem Inter";
export const baseInputSlotsPlaceholderFontWeight = "400";
export const baseInputSlotsLabelWrapperPx = "0px";
export const baseInputSlotsLabelWrapperBgColor = "#ffffff00";
export const baseInputSlotsLabelWrapperBorderRadius = "0.25rem";
export const baseInputSlotsLabelWrapperResizingW = "resizing-w-fill";
export const baseInputSlotsLabelWrapperResizingH = "resizing-h-hug";
